"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue3_compat_1 = require("@/client/vue3-compat");
const PlanetaryTrackReward_vue_1 = require("./PlanetaryTrackReward.vue");
exports.default = (0, vue3_compat_1.defineComponent)({
    name: 'PlanetaryTrackRewards',
    props: {
        rewards: {
            type: Object,
            required: true,
        },
        type: {
            type: String,
        },
        gameOptions: {
            type: Object,
            required: true,
        },
    },
    components: {
        PlanetaryTrackReward: PlanetaryTrackReward_vue_1.default,
    },
    data() {
        return {};
    },
    computed: {
        myReward() {
            switch (this.type) {
                case 'risingPlayer':
                    return this.rewards.risingPlayer;
                case 'everyone':
                    return this.rewards.everyone.concat(this.rewards.mostTags);
                default:
                    return [];
            }
        },
        mostTags() {
            return this.type === 'everyone' && this.rewards.mostTags.length > 0;
        },
    },
});
